module.exports = __webpack_public_path__ + "static/media/bg-tab-popup-active-web.bc4b4478.png";